import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tailwind.css'; // Keep if you're using Tailwind
import './index.css'; // Optional additional styles
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />
);

// Register service worker
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then(registration => {
        console.log('Service Worker registered');

        // Listen for updates
        registration.onupdatefound = () => {
          const installingWorker = registration.installing;
          if (installingWorker) {
            installingWorker.onstatechange = () => {
              if (
                installingWorker.state === 'installed' &&
                navigator.serviceWorker.controller
              ) {
                // New update available
                if (window.confirm('New version available. Reload to update?')) {
                  if (registration.waiting) {
                    registration.waiting.postMessage({ type: 'SKIP_WAITING' });
                  }
                  window.location.reload();
                }
              }
            };
          }
        };
      })
      .catch(err => console.error('Service Worker error:', err));
  });
}

// Optional: Measure performance
reportWebVitals();
